// extracted by mini-css-extract-plugin
module.exports = {"inspirationWrapper":"InspirationTab_inspirationWrapper__OdnI9","product-listing__row":"InspirationTab_product-listing__row__rUgtL","d-block":"InspirationTab_d-block__yPMzD"};